import { FunctionalComponent, h } from 'preact';

import { PropertyCardIconGroupTemplate as CommonPropertyCardIconGroupTemplate } from 'common/module/property/card/icon-group/template';
import { PropertyCardIconGroupTemplatePropsInterface } from 'common/module/property/card/icon-group/template-props.interface';

export const PropertyCardIconGroupTemplate: FunctionalComponent<PropertyCardIconGroupTemplatePropsInterface> = (
  props
) => <CommonPropertyCardIconGroupTemplate {...props} />;
